import { FeatureQueryResponse } from "../redux/services/types";
import { parseLanguageObject } from "./parseLanguageObject";
import { FloorConfig } from "../components/Map/plugins/floor-control";

interface Props {
  fromId: string;
  toId: string;
  originalRouteFloor?: FloorConfig;
  originData?: FeatureQueryResponse;
  destinationData?: FeatureQueryResponse;
  defaultLanguage: string;
}

export const extractRoutingData = ({
  fromId,
  toId,
  originalRouteFloor,
  originData,
  destinationData,
  defaultLanguage,
}: Props) => {
  const splitFromId = fromId.split(",");
  const splitToId = toId.split(",");

  const fromIdIsLatLng = splitFromId?.length === 2;
  const toIdIsLatLng = splitToId?.length === 2;

  const fromData = fromIdIsLatLng
    ? {
        from_latitude: Number(splitFromId[1]),
        from_longitude: Number(splitFromId[0]),
        from_floor: originalRouteFloor?.floor,
      }
    : {
        from_lm_id: fromId,
        from_name: originData
          ? parseLanguageObject(originData.label.name, defaultLanguage)
          : "",
      };

  const toData = toIdIsLatLng
    ? {
        to_latitude: Number(splitToId[1]),
        to_longitude: Number(splitToId[0]),
        to_floor: originalRouteFloor?.floor,
      }
    : {
        to_lm_id: toId,
        to_name: destinationData
          ? parseLanguageObject(destinationData.label.name, defaultLanguage)
          : "",
      };

  return {
    fromData,
    toData,
  };
};
